import type { ActualCostCompletenessStatus } from '@/common/api/types/itemFinancials';

export const MAX_MONETARY_AMOUNT = 9_999_999_999_999.99;

export type FinancialSaveState =
  | { status: 'idle' }
  | { status: 'pending' }
  | { status: 'success' }
  | { status: 'error'; message: string };

export interface ItemFinancialFigures {
  descendantsBudgetAmount?: number | null;
  capexPercent?: number | null;
  plannedLaborHours?: number | null;
  durationLabel?: string | null;
  forecastedRevenue?: number | null;
  descendantsForecastRevenueAmount?: number | null;
  selfActualCost?: number | null;
  selfActualCostStatus?: ActualCostCompletenessStatus | null;
  selfActualHours?: number | null;
  totalActualCost?: number | null;
  totalActualCostStatus?: ActualCostCompletenessStatus | null;
}
